module.exports = __webpack_public_path__ + "img/group_remove_opsz24.90b30fa6.svg";